import clsx from 'clsx';
import React, {useMemo} from 'react';
import {Label} from '@lightricks/react-design-system';
import {getStatusLabels} from '@/views/creators/recruit-crm/constants';
import {
  RecruitmentFilterStatus,
  RecruitmentStatus,
} from '@/views/creators/recruit-crm/types';
import styles from './StatusBadge.module.scss';

interface StatusBadgeProps {
  status: RecruitmentStatus;
  removed: boolean;
  className?: string;
}

/**
 * Badge component for displaying recruitment status with color coding
 */
function StatusBadge({status, removed, className}: StatusBadgeProps) {
  const statusLabels = useMemo(() => getStatusLabels(), []);
  const displayStatus: RecruitmentFilterStatus = removed ? 'removed' : status;

  return (
    <Label
      size="sm"
      className={clsx(styles.badge, styles[displayStatus], className)}
      data-status={displayStatus}
    >
      {statusLabels[displayStatus]}
    </Label>
  );
}

export default StatusBadge;
